@if (isMobile()) {
  @if (hasMore()) {
    <div class="loadMore">
      <button type="button" mat-button class="btn outlineActionButton" (click)="loadMore()">
        {{ 'GENERAL.SEE_MORE' | translate }}
      </button>
    </div>
  }
} @else {
  <div class="customTableRadius paginatorControls d-flex justify-content-between align-items-center flex-wrap">
    <div class="d-flex flex-wrap align-items-center">
      <pagination-controls class="customNgxPaginator"
        [id]="config.id"
        [maxSize]="7"
        [directionLinks]="true"
        [previousLabel]="''"
        [nextLabel]="''"
        [screenReaderPaginationLabel]="'PAGINATOR.PAGINATOR' | translate"
        [screenReaderPageLabel]="'GENERAL.PAGE' | translate"
        [screenReaderCurrentLabel]="'PAGINATOR.CURRENT_PAGE' | translate"
        (pageChange)="onPageChange($event)">
      </pagination-controls>

      <div class="paginatorPageCounter">
        {{config.currentPage}} {{'GENERAL.OF' | translate}}
        {{getMaxPage()}}
        {{(getPageCountLabel() | translate).toLowerCase()}}
      </div>
    </div>

    @if (showPageSizeOption) {
      <div>
        <mat-form-field class="customMatFormField" appearance="outline">
          <mat-select [value]="config.itemsPerPage" (selectionChange)="onPageSizeChange($event.value)" hideSingleSelectionIndicator="true">
            @for (pageSize of pageSizeOptions; track pageSize) {
              <mat-option [value]="pageSize">
                {{ 'PAGINATOR.SHOW' | translate }} {{pageSize}} {{ 'PAGINATOR.PER_PAGE' | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>
}
